// extracted by mini-css-extract-plugin
export var wrapper = "y_b";
export var error = "y_ch";
export var checkbox = "y_cj";
export var label = "y_bP";
export var checked = "y_ck";
export var input = "y_cl";